// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__V5zKx","inner":"Form_inner__17Opm","range":"Form_range__I2Znx","name":"Form_name__2_AqH","actions":"Form_actions__2aTlJ"};